import { Navigate, Outlet } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

const RequireAuth: React.FC = () => {
  const isAuth = useAuth()
  return isAuth ? <Outlet /> : <Navigate to='/login' replace />
}

export default RequireAuth
